angular.module('mtic.components.login')
.component('mticFinalizationAccountSetup', {
  
  templateUrl: 'template.html',

  bindings: {
    flow: '=',
    profile: '<'
  },

  controllerAs: 'setup',

  controller(
    $scope, 
    language, 
    EventManager, 
    IAM_CODES
  ) {

    // this
    var setup = this;
    
    // event manager
    var eventManager = new EventManager('mticFinalizationAccountSetup', $scope);

    // model
    $scope.language = language;
    setup.isSelected = function(id) {
      var isSelected = setup.flow.accountType === id;
      if(isSelected){
        return {
          'button': true,
          'btn-new-mtic': true,
          'selected': true
        }
      }
      else{
        return {
          'button': true,
          'btn-new-mtic': true,
          'not-selected': true
        }
      }
    }
    setup.setType = function(id){
      if(setup.flow.isTesting) {
        setup.flow.setType(id, 'account')
        if(id === IAM_CODES.LANG.TEACHER) {
          setup.flow.setType(IAM_CODES.LANG.TEACHER, 'account')
          setup.flow.setType(IAM_CODES.LANG.RETURNING, 'returning')
        }
      }
    };

  }
});
